const accessPayroll = "ACCESS_PAYROLL";
const visiblePayroll = "ACCESS_DATA_SECURITY|SALARY";
export const PERMISSIONS_CONFIG = {
    'payrollOngoing': {
        'ACCESS': `${accessPayroll}|ONGOING`,
        'VISIBLE': `${visiblePayroll}|PAYROLL_PERIOD`,
        'CREATE_PERIOD': false,
    },
    'payrollAll': {
        'ACCESS': `${accessPayroll}|ALL`,
        'VISIBLE': `${visiblePayroll}|ALL_PERIODS`,
        'CREATE_PERIOD': "CREATE_PAYROLL|ONGOING|ALL|CREATE_PERIOD"
    }
};